import React from 'react';

function Footer() {
  return (
    <footer id="contact">
      <p>© 2025 heifersaero. All rights reserved.</p>
      <p>
        <a href="mailto:heifersaero.com">heifersaero.com</a> |{' '}
        <a href="tel:+1234567890">+1 (234) 567-890</a>
      </p>
    </footer>
  );
}

export default Footer;